import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { IntegracaoRedeForm } from "./components/IntegracaoRedeForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integração Rede" />
            <Loading />
            <IntegracaoRedeForm />
        </>
    )
}
